export default (params) => ({
  trigger: {
    name: 'content_blocks.highlighted_product.click_reviews_in_highlighted_product',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
